import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte, BokkzAlgDataService, IncomeTaxEntity,
  OmschrijvingEnBedrag,
  PGASpecifiekeZorgkosten
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { Event, NavigationEnd, Router } from "@angular/router";
import { filter, Subscription } from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-behandelkosten',
  templateUrl: './behandelkosten.component.html',
  styleUrls: ['./behandelkosten.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})

export class BehandelkostenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;

    @Input() public id!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    private focusedElementId: string | null = null;

    public behandelKostenFg = {} as FormGroup

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router,private fb: FormBuilder) {
        this.behandelKostenFg = this.fb.group({
            behandelKosten:
                this.fb.array<PGASpecifiekeZorgkosten>([])
        })
    }

    get behandelKosten(): FormArray {
        return this.behandelKostenFg.get('behandelKosten') as FormArray;
    }

    addRijBehandelkosten(): void {
        this.behandelKosten.push(this.createBehandelkostenFormGroup()
        )
    }

    verwijderRijBehandelkosten(index: number): void {
        this.behandelKosten.removeAt(index);
        this.behandelKostenFg.updateValueAndValidity()
        this.behandelKostenFg.markAsDirty()
        this.saveForm()
    }



    createBehandelkostenFormGroup(behandeling?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: behandeling ? behandeling.omschrijving : undefined,
            bedrag: behandeling ? behandeling.bedrag : undefined
        } as OmschrijvingEnBedrag));
    }

    public ngOnInit(): void {
     this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.behandelKosten.dirty;
  }


  private updateForm(): void {
        const behandelkostenLijst = this.aangifte?.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten?.behandelKosten || [];
        const formArray = this.behandelKostenFg.get('behandelKosten') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > behandelkostenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < behandelkostenLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(behandelkostenLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createBehandelkostenFormGroup(behandelkostenLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                persoonsgebondenAftrek: {
                    ...this.aangifte.persoonsgebondenAftrek,
                    pgaSpecifiekeZorgkosten: {
                        ...this.aangifte.persoonsgebondenAftrek?.pgaSpecifiekeZorgkosten,
                        behandelKosten: this.behandelKostenFg.value.behandelKosten
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
    }
}
